import spikevaxPaperboardCarton from '../assets/images/ProductDetails/SPIKEVAX_80777-110-96_Paperboard_Carton.jpg';
import spikevaxSyringe from '../assets/images/ProductDetails/SPIKEVAX_80777-110-01_PFS.jpg';
import covid19PaperboardCarton from '../assets/images/ProductDetails/COVID-19_EUA_80777-291-80_Paperboard_Carton.jpg';
import covid19Syringe from '../assets/images/ProductDetails/COVID-19_EUA_80777-291-09_PFS.jpg';
import mresviaPaperboardCarton from '../assets/images/ProductDetails/mRESVIA_carton.jpg';
import mresviaSyringe from '../assets/images/ProductDetails/mRESVIA_product.jpg';
import mresviaBoth from '../assets/images/ProductDetails/mRESVIA_both.jpg';

export const productImages = {
    '70506': [
        {
            url: spikevaxPaperboardCarton,
            width: 418,
            height: 418,
            imageType: 'PAPERBOARD'
        },
        {
            url: spikevaxSyringe,
            width: 418,
            height: 418,
            imageType: 'SYRINGE'
        },
    ],
    '70840': [
        {
            url: covid19PaperboardCarton,
            width: 418,
            height: 418,
            imageType: 'PAPERBOARD'
        },
        {
            url: covid19Syringe,
            width: 418,
            height: 418,
            imageType: 'SYRINGE'
        },
    ],
    '70545': [
        {
            url: mresviaPaperboardCarton,
            width: 418,
            height: 418,
            imageType: 'PAPERBOARD'
        },
        {
            url: mresviaBoth,
            width: 418,
            height: 418,
            imageType: 'OTHER'
        },
        {
            url: mresviaSyringe,
            width: 418,
            height: 418,
            imageType: 'SYRINGE'
        },
    ],
}